import { createApiHooks, httpStatusAsData } from '@apis/next/common';
import {
  PutSeaWaybill,
  PostSeaWaybill,
  PatchSeaWaybill,
  SeaWaybill,
} from '@models/next/SeaWaybill';
import { z } from 'zod';

export const seaWaybillApis = createApiHooks('/sea-waybill', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
    ],
    response: SeaWaybill,
  },
]);

export const dashboardSeaWaybillApis = createApiHooks('/dashboard/sea-waybill', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
    ],
    response: SeaWaybill.nullable(),
  },
  {
    method: 'put',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
      {
        name: 'body',
        schema: PutSeaWaybill,
        type: 'Body',
      },
    ],
    response: SeaWaybill,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        name: 'id',
        schema: z.number(),
        type: 'Path',
      },
      {
        name: 'body',
        schema: PatchSeaWaybill,
        type: 'Body',
      },
    ],
    response: SeaWaybill,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        name: 'body',
        schema: PostSeaWaybill,
        type: 'Body',
      },
    ],
    response: z.unknown(),
  },
]);

dashboardSeaWaybillApis.client.use(
  'get',
  '/dashboard/sea-waybill/:id',
  httpStatusAsData(404, null),
);
